import React from 'react';
import Loadable from 'react-loadable';

export default component =>
  Loadable({
    loader: () => component(),
    loading: () => <div />
  });
